import { cellRenderParseData } from '../../utils/functions';

const columnDataGrid = [
  {
    dataField: 'qcId',
    caption: 'СК (ПФ)',
    dataType: 'string'
  },
  {
    dataField: 'accountingDate',
    caption: 'Дата СК (ПФ)',
    cellRender: cellRenderParseData,
    dataType: 'date'
  },
  {
    dataField: 'batchId',
    caption: 'Партия SAP',
    dataType: 'string'
  },
  {
    dataField: 'cgId',
    caption: 'Номер партии',
    dataType: 'string'
  },
  {
    dataField: 'actualPieceId',
    caption: 'Номер УЕ',
    dataType: 'string'
  },
  {
    dataField: 'psStatusName',
    caption: 'Статус УЕ',
    dataType: 'string'
  },
  {
    dataField: 'quantity',
    caption: 'Кол-во',
    dataType: 'string'
  },
  {
    dataField: 'unitShort',
    caption: 'ЕИ',
    dataType: 'string'
  },
  {
    dataField: 'quantityRemain',
    caption: 'Остаточный вес',
    dataType: 'number'
  },
  {
    dataField: 'weightOff',
    caption: 'Кол-во списания',
    dataType: 'number'
  },
  {
    dataField: 'percentWasteMaterial',
    caption: '% отходов',
    dataType: 'number'
  },
  {
    dataField: 'zdvlOrderNumId',
    caption: 'Заказ ZDVL',
    dataType: 'string'
  },
  {
    dataField: 'zdvlOrderLineId',
    caption: 'Позиция ZDVL',
    dataType: 'number'
  }
];

export default columnDataGrid;
